<!--
 * @Author: Shber
 * @Date: 2022-10-13 12:05:05
 * @LastEditors: Shber
 * @LastEditTime: 2023-05-11 19:12:04
 * @Description:
-->
<template>
  <div class="action">
    <van-action-sheet
      :show="isShow"
      :title="title"
      @cancel="ruleCancel"
    >
      <div v-if="title=='活动规则'" class="sheet_cont">
        <div>
          <div>由「名厨MINGCHU」与「欣和」共同发起的「欣探行动･酱香大师挑战赛」，活动时间为5月12日-5月25日。</div>
          <ol class="decimal">
            <li>点击立即报名按钮，参与本次活动；</li>
            <li>参与完成每日任务、餐厅打卡、名厨问答、收藏主题，提升「名厨力」排名；</li>
            <li>提交「酱香」创意与灵感，中签后以产品包为核心调味料，提交反馈一道完整原创作品。</li>
          </ol>
        </div>
        <div>
          <div class="RulesTitle">评选规则</div>
          <ol class="decimal">
            <li>依据试用挑战作品质量、「名厨力」排名（各占比 50%），综合评选出 1 位用户，获得「杭州米其林指南发布庆典门票」；</li>
            <li>依据「名厨力」排名、近半年内完整作品数量及热度值（各占比 50%），综合评选出 6 名用户，获得「探访杭州新晋米其林餐厅」机会；</li>
            <li>「名厨力」排名前 10 的用户即可获得名厨定制周边。</li>
          </ol>
        </div>
        <div class="Rules">
          <div class="RulesTitle">常见问题</div>
          <div class="sheetRules">
            <div>1.什么是名厨职业认证？</div>
            <div>名厨职业认证是用户在名厨App上的职业身份认证。用于证明用户的职业身份真实有效，也代表了名厨对用户职业身份的认可。目前名厨只提供对厨师用户的身份认证，经营者、美食爱好者和供应商无法进行职业认证。</div>
          </div>
          <div class="sheetRules">
            <div>2.如何进行职业认证？</div>
            <div>请到名厨App： 我的 →认证中心→职业认证，上传认证资料完成认证。</div>
          </div>
          <div class="sheetRules">
            <div>3. 为什么我报名后没有看到专属头像挂件？</div>
            <div>请前往手机应用商店搜索「名厨MINGCHU」直接进行更新至最新版本（3.5.60）即可看到专属头像挂件。</div>
          </div>
        </div>
      </div>
      <div v-else class="sheet_content sheet_degree">
        <div style="padding-top: 16px;">
          <div>「名厨力」是什么？</div>
          <div>名厨力，即任务分值，活动排行榜将根据各项任务累计分值进行排名。</div>
        </div>
        <div style="padding-top: 16px;">
          <div>怎样获得更多「名厨力」？</div>
          <ol style="width:291px;height: auto;display: block;">
            <li>1、分享活动链接，邀请更多好友报名； </li>
            <li>2、完成每日任务，关注餐厅、主题，参与名厨问答； </li>
            <li>3、参与试用挑战，提交完整的创意与灵感，获得「欣和酱香礼包」并反馈完整原创作品。 </li>

          </ol>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>
<script setup>
import { reactive, watch, ref, defineEmits, defineProps } from 'vue'
import { ActionSheet as vanActionSheet } from 'vant'

const emits = defineEmits(['onCancel'])
const props = defineProps({
  ruleShow: {
    type: Boolean,
    default: false
  },
  ruleTitle: {
    type: String,
    default: '活动规则'
  },
  ruleType: {
    type: Number,
    default: 0
  }
})
const isShow = ref(false) // 弹框隐藏展示
const title = ref('活动规则')
watch(
  () => [props.ruleShow, props.ruleTitle], ([newShow, newTitle], [oldShow, oldTitle]) => {
    isShow.value = newShow
    title.value = newTitle
  }
)
const ruleCancel = () => {
  emits('onCancel', false)
}

</script>
<style scoped>
.Rules{padding-bottom:30px;}
.RulesTitle{font-size: 18px;font-weight: bold;color: #333333;text-align:center;padding-top:24px;padding-bottom:4px;}
.sheetRules{color:#333333 ;font-size:16px;font-weight: bold;padding-top:12px;}
.sheetRules div:nth-child(2){padding-top:4px;color:#666666;font-size: 14px;font-weight:400;}
.decimal{list-style-type: decimal;padding-left:16px;}
.decimal li{padding-top:4px;}
.sheet_cont{height:517px;width: 311px;margin-left: 32px;margin-top: 15px; padding-bottom: 30px;color:#666666;font-size:14px;}
.sheet_content{height: 517px;width: 311px;margin-left: 32px;margin-top: 6px; padding-bottom: 30px;}
.sheet_content div{width: 100%;}
.sheet_content div div:nth-child(1){font-size: 18px;font-weight: bold;color: #333333;display: block;}
.sheet_content div div:nth-child(2){font-size: 14px;color: #333333;padding-top: 4px;}
.sheet_content div div:nth-child(3){font-size: 14px;color: #333333;padding-top: 4px;}
.sheet_content div div:nth-child(2) span{font-size: 14px;color: #333333;display: block;}
.sheet_content .last:last-child{ padding-bottom: 30px;}
.sheet_degree{height: auto !important;}
.sheet_degree li{font-size: 14px;}
.mingchu{font-size: 14px;padding-top: 20px;padding-bottom: 20px;}
.text-area{width: 100%; height: 54vh;}
.action :deep(.van-action-sheet__header){font-size: 18px !important;font-weight:bold !important;}
.action :deep(.van-action-sheet__close){color: #333 !important;}
</style>

